var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sv-tab-item",class:[
    _vm.currentSelected ? _vm.activeClass : '',
    {
      'sv-tab-selected': _vm.currentSelected,
      'sv-tab-disabled': _vm.disabled
    }
  ],style:(_vm.style),on:{"click":_vm.onItemClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }